webpackJsonp([8],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949221c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__(141);
function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-949221c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_949221c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pageLoading && !_vm.hideTopBar),expression:"!pageLoading && !hideTopBar"}],staticClass:"top-bar"},[_c('div',{staticClass:"primary-actions"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayBack),expression:"displayBack"}],staticClass:"back-button",attrs:{"to":"/"}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_left")])]),_vm._v(" "),(_vm.editorMode)?_c('div',{staticClass:"presentation-title"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.presentationTitle),expression:"presentationTitle"}],attrs:{"type":"text"},domProps:{"value":(_vm.presentationTitle)},on:{"blur":_vm.onBlur,"input":function($event){if($event.target.composing){ return; }_vm.presentationTitle=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"brand"},[_c('router-link',{attrs:{"to":"/"}},[_c('svg',{attrs:{"preserveAspectRatio":"xMidYMid meet","width":"40","height":"40","viewBox":"0 0 155 117","xmlns":"http://www.w3.org/2000/svg"}},[_c('symbol',{attrs:{"id":"logo"}},[_c('path',{attrs:{"d":"M91 97L25 20H10a10 10 0 1 1 0-20h135a10 10 0 0 1 0 20H63l66 77h16a10 10 0 0 1 0 20H10a10 10 0 0 1 0-20h81z"}})]),_vm._v(" "),_c('use',{attrs:{"xlink:href":"#logo"}})])])],1),_vm._v(" "),_c('div',{staticClass:"secondary-actions"},[(_vm.editorMode)?_c('a',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.presentationUrl),expression:"presentationUrl",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],ref:"copyButton",attrs:{"href":"#"}},[_c('i',{staticClass:"material-icons"},[_vm._v("share")]),_vm._v(" "),_c('span',[_vm._v("Share")])]):_vm._e(),_vm._v(" "),(_vm.editorMode)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.doSavePresentation($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" "),_c('span',[_vm._v("Save")])]):_vm._e(),_vm._v(" "),(_vm.editorMode)?_c('router-link',{class:{ disabled: _vm.savingState },attrs:{"to":{ name: 'presenter', params: { presentationId: _vm.presentationId }},"disabled":_vm.savingState}},[_c('i',{staticClass:"material-icons"},[_vm._v("play_circle_outline")]),_vm._v(" "),_c('span',[_vm._v("Present")])]):_vm._e(),_vm._v(" "),(_vm.$auth.check())?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")]),_vm._v(" "),_c('span',[_vm._v("Log out")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingOverlay_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186e798e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingOverlay_vue__ = __webpack_require__(144);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186e798e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186e798e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-overlay"},[_c('svg',{attrs:{"preserveAspectRatio":"xMidYMid meet","width":"100","height":"100","vector-effect":"non-scaling-stroke","viewBox":"-5 0 165 117","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M91 97L25 20H10a10 10 0 1 1 0-20h135a10 10 0 0 1 0 20H63l66 77h16a10 10 0 0 1 0 20H10a10 10 0 0 1 0-20h81z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.appConditionalStyles},[_c('loading-overlay',{attrs:{"show":_vm.pageLoading}}),_vm._v(" "),_c('top-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pageLoading),expression:"!pageLoading"}],staticClass:"content"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutations__ = __webpack_require__(45);




/* harmony default export */ __webpack_exports__["a"] = ({
  auth: __webpack_require__(200),
  http: __webpack_require__(201),
  router: __webpack_require__(202),
  loginData: { url: 'user/login', method: 'POST', fetchUser: true, redirect: '/dashboard' },
  logoutData: { url: 'user/logout', method: 'POST', redirect: '/', makeRequest: false },
  fetchData: { url: 'user/me', method: 'GET', enabled: true },
  registerData: { url: 'user/register', method: 'POST', fetchUser: true, redirect: '/login' },
  refreshData: { url: 'user/refresh', method: 'POST', enabled: true, interval: 2 },
  authRedirect: { name: 'landing' },
  forbiddenRedirect: { name: '/dashboard' },
  parseUserData: function parseUserData(req) {
    var u = null;
    if (req.user) u = req.user;
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_1__store_mutations__["a" /* AUTHENTICATE_USER */], u);
    return u;
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_presentation__ = __webpack_require__(38);






var blankPresentation = {
  title: 'New Presentation',
  slides: [{
    backgroundColour: '#FFFFFF',
    elements: [{
      id: 0,
      type: 'TEXT',
      properties: {
        x: '30px',
        y: '30px',
        fill: '#000000',
        fontFamily: 'Verdana',
        fontSize: '20px',
        content: 'Title goes here'
      }
    }]
  }]
};

var state = {
  presentations: {}
};

var getters = {
  presentations: function presentations(state) {
    return state.presentations;
  }
};

var actions = {
  createPresentation: function createPresentation(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api_presentation__["d" /* savePresentation */](blankPresentation);

            case 3:
              res = _context.sent;

              commit('fetchPresentation', res.data.presentation);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  fetchPresentations: function fetchPresentations(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api_presentation__["c" /* getPresentations */]();

            case 3:
              res = _context2.sent;

              commit('fetchPresentations', res.data.presentations);
              commit('setPageLoading', false, { root: true });
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  createNewPresentation: function createNewPresentation(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var title, presentation;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              title = window.prompt('Please enter a name for your presentation');

              if (title) {
                _context3.next = 5;
                break;
              }

              window.alert('Please enter a name.');
              return _context3.abrupt('return');

            case 5:
              presentation = blankPresentation;

              presentation.title = title;

              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__api_presentation__["d" /* savePresentation */](presentation).then(function (res) {
                commit('fetchPresentation', res.data.presentation);
              }));

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 10]]);
    }))();
  },
  deletePresentation: function deletePresentation(_ref4, presentationId) {
    var commit = _ref4.commit;

    var confirm = window.confirm('Are you sure you want to delete this presentation?');
    if (confirm) {
      __WEBPACK_IMPORTED_MODULE_4__api_presentation__["a" /* deletePresentation */](presentationId).then(function () {
        return commit('deletePresentation', presentationId);
      }).catch(function () {
        return window.alert('Failed to delete presentation, please try again');
      });
    }
  },
  renamePresentation: function renamePresentation(_ref5, presentation) {
    var commit = _ref5.commit;

    var newTitle = window.prompt('Please enter the new title');
    if (!newTitle) {
      window.alert('The entered title wasn\'t valid. Please try again.');
    }

    var p = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(presentation));
    p.title = newTitle;

    __WEBPACK_IMPORTED_MODULE_4__api_presentation__["d" /* savePresentation */](p).then(function (res) {
      return commit('fetchPresentation', res.data.presentation);
    }).catch(function (res) {
      return window.alert(res.err.message);
    });
  }
};

var mutations = {
  fetchPresentations: function fetchPresentations(state, presentations) {
    for (var i = 0; i < presentations.length; i += 1) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.presentations, presentations[i].id, presentations[i]);
    }
  },
  fetchPresentation: function fetchPresentation(state, presentation) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.presentations, presentation.id, presentation);
  },
  deletePresentation: function deletePresentation(state, presentationId) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(state.presentations, presentationId);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_presentation__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_socket_io_client__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__socket_mutations__ = __webpack_require__(193);










var state = {
  socket: null,
  selectedSlideIndex: 0,
  zoomLevel: 1,
  selectedElementIndex: -1,
  activeUsers: [],
  dirty: false,

  presentation: {
    id: -1,
    title: '',
    slides: []
  }
};

var ZOOM_STEP_LEVEL = 0.2;
var DEFAULT_NEW_SLIDE = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
  backgroundColour: '#FFFFFF',
  elements: [{
    id: 0,
    type: 'TEXT',
    properties: {
      x: '30px',
      y: '30px',
      fill: '#000000',
      fontFamily: 'Verdana',
      fontSize: '20px',
      content: 'Slide title'
    }
  }, {
    id: 1,
    type: 'TEXT',
    properties: {
      x: '30px',
      y: '80px',
      fill: '#000000',
      fontFamily: 'Verdana',
      fontSize: '15px',
      content: 'Slide body text'
    }
  }]
});
var DEFAULT_NEW_TEXT = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
  type: 'TEXT',
  properties: {
    x: '210px',
    y: '140px',
    fill: '#000000',
    fontFamily: 'Verdana',
    fontSize: '15px',
    content: 'New text box'
  }
});
var DEFAULT_NEW_IMAGE = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
  type: 'IMAGE',
  properties: {
    x: '265px',
    y: '45px',
    width: '150px',
    height: '150px',
    href: 'https://picsum.photos/150'
  }
});

var getters = {
  socket: function socket(state) {
    return state.socket;
  },
  presentation: function presentation(state) {
    return state.presentation;
  },
  presentationId: function presentationId(state) {
    return state.presentation ? state.presentation.id : -1;
  },
  title: function title(state) {
    return state.presentation.title;
  },
  currentSlide: function currentSlide(state) {
    if (!state.presentation.slides.length || !state.presentation.slides[state.selectedSlideIndex]) {
      return null;
    }

    return state.presentation.slides[state.selectedSlideIndex];
  },
  selectedSlideIndex: function selectedSlideIndex(state) {
    return state.selectedSlideIndex;
  },
  selectedElementIndex: function selectedElementIndex(state) {
    return state.selectedElementIndex;
  },
  currentElement: function currentElement(state) {
    if (!state.presentation.slides.length || state.selectedSlideIndex < 0 || state.selectedElementIndex < 0) {
      return null;
    }

    return state.presentation.slides[state.selectedSlideIndex].elements.find(function (el) {
      return el.id === state.selectedElementIndex;
    });
  },
  slides: function slides(state) {
    return state.presentation ? state.presentation.slides : [];
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  activeUsers: function activeUsers(state) {
    return state.activeUsers;
  },
  dirty: function dirty(state) {
    return state.dirty;
  }
};

var actions = {
  initSocket: function initSocket(_ref) {
    var commit = _ref.commit;

    commit('initSocket');
  },
  fetchPresentation: function fetchPresentation(_ref2, presentationId) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                  var res;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return __WEBPACK_IMPORTED_MODULE_6__api_presentation__["b" /* getPresentation */](presentationId);

                        case 3:
                          res = _context.sent;


                          commit('setPresentation', res.data.presentation);
                          commit('setPageLoading', false, { root: true });
                          resolve();
                          _context.next = 13;
                          break;

                        case 9:
                          _context.prev = 9;
                          _context.t0 = _context['catch'](0);

                          console.error(_context.t0);
                          reject(_context.t0);

                        case 13:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[0, 9]]);
                }));

                return function (_x, _x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  savePresentation: function savePresentation(_ref4, _ref5) {
    var _this2 = this;

    var commit = _ref4.commit;
    var presentation = _ref5.presentation;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_6__api_presentation__["d" /* savePresentation */](presentation).then(function (res) {
                            commit('setPresentation', res.data.presentation);
                            console.info('Presentation successfully saved');
                            resolve();
                          }).catch(function (res) {
                            return window.alert(res.err.message);
                          }));

                        case 4:
                          _context3.prev = 4;
                          _context3.t0 = _context3['catch'](0);

                          console.error(_context3.t0);
                          reject(_context3.t0);

                        case 8:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2, [[0, 4]]);
                }));

                return function (_x3, _x4) {
                  return _ref6.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  zoomIn: function zoomIn(_ref7) {
    var commit = _ref7.commit;

    commit('zoomIn');
  },
  zoomOut: function zoomOut(_ref8) {
    var commit = _ref8.commit;

    commit('zoomOut');
  },
  updateTitle: function updateTitle(_ref9, value) {
    var commit = _ref9.commit;

    commit('setTitle', value);
  },
  selectSlideFromList: function selectSlideFromList(_ref10, selectedSlideIndex) {
    var commit = _ref10.commit;

    commit('setSelectedSlideIndex', selectedSlideIndex);
  },
  createSlide: function createSlide(_ref11) {
    var commit = _ref11.commit;

    commit('createSlide');
  },
  replaceSlide: function replaceSlide(_ref12, _ref13) {
    var commit = _ref12.commit;
    var slideIndex = _ref13.slideIndex,
        slide = _ref13.slide;

    commit('replaceSlide', { slideIndex: slideIndex, slide: slide });
  },
  deleteSlide: function deleteSlide(_ref14, slideIndex) {
    var commit = _ref14.commit;

    var confirm = window.confirm('Are you sure you want to delete this slide?');
    if (confirm) {
      commit('deleteSlide', slideIndex);
    }
  },
  moveSlide: function moveSlide(_ref15, _ref16) {
    var commit = _ref15.commit;
    var draggingSlideIndex = _ref16.draggingSlideIndex,
        replaceSlideIndex = _ref16.replaceSlideIndex;

    commit('moveSlide', { draggingSlideIndex: draggingSlideIndex, replaceSlideIndex: replaceSlideIndex });
  },
  setSlides: function setSlides(_ref17, slides) {
    var commit = _ref17.commit;

    commit('setSlides', slides);
  },
  setElements: function setElements(_ref18, _ref19) {
    var commit = _ref18.commit;
    var slideIndex = _ref19.slideIndex,
        elements = _ref19.elements;

    commit('setElements', { slideIndex: slideIndex, elements: elements });
  },
  setUsersList: function setUsersList(_ref20, usersList) {
    var commit = _ref20.commit;

    commit('setUsersList', usersList);
  },
  createText: function createText(_ref21, socket) {
    var commit = _ref21.commit;

    commit('createText');
    commit('notifyCreatedElement', socket);
  },
  createImage: function createImage(_ref22) {
    var commit = _ref22.commit;

    var url = window.prompt('Please enter the URL of new image');
    var height = window.prompt('Please enter the height (in pixels)');
    var width = window.prompt('Please enter the width (in pixels)');

    if (!url || !height || !width) {
      window.alert('Please enter a valid image URL, height (pixels) and width (pixels)');
      return null;
    }

    commit('createImage', { url: url, height: height, width: width });
  },
  inspectElement: function inspectElement(_ref23, selectedElementIndex) {
    var commit = _ref23.commit;

    commit('setSelectedElementIndex', selectedElementIndex);
  },
  deleteElement: function deleteElement(_ref24, selectedElementIndex) {
    var commit = _ref24.commit;

    var confirm = window.confirm('Are you sure you want to delete this?');
    if (confirm) {
      commit('deleteElement', selectedElementIndex);
    }
  },
  updateBackgroundColour: function updateBackgroundColour(_ref25, value) {
    var commit = _ref25.commit;

    commit('setBackgroundColour', value);
  },
  updateX: function updateX(_ref26, _ref27) {
    var commit = _ref26.commit;
    var element = _ref27.element,
        value = _ref27.value;

    commit('setElementX', { element: element, value: value });
  },
  updateY: function updateY(_ref28, _ref29) {
    var commit = _ref28.commit;
    var element = _ref29.element,
        value = _ref29.value;

    commit('setElementY', { element: element, value: value });
  },
  updateCoordinates: function updateCoordinates(_ref30, _ref31) {
    var commit = _ref30.commit;
    var element = _ref31.element,
        x = _ref31.x,
        y = _ref31.y;

    commit('setElementCoordinates', { element: element, x: x, y: y });
  },
  updateFontFamily: function updateFontFamily(_ref32, _ref33) {
    var commit = _ref32.commit;
    var element = _ref33.element,
        value = _ref33.value;

    commit('setElementFontFamily', { element: element, value: value });
  },
  updateFontSize: function updateFontSize(_ref34, _ref35) {
    var commit = _ref34.commit;
    var element = _ref35.element,
        value = _ref35.value;

    commit('setElementFontSize', { element: element, value: value });
  },
  updateFill: function updateFill(_ref36, _ref37) {
    var commit = _ref36.commit;
    var element = _ref37.element,
        value = _ref37.value;

    commit('setElementFill', { element: element, value: value });
  },
  updateContent: function updateContent(_ref38, _ref39) {
    var commit = _ref38.commit;
    var element = _ref39.element,
        value = _ref39.value;

    commit('setElementContent', { element: element, value: value });
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  initSocket: function initSocket(state) {
    // var address = window.location.origin
    // address += ':3000'
    var address = 'https://slidekick.daniel-waghorn.com:3000/';
    state.socket = __WEBPACK_IMPORTED_MODULE_7_socket_io_client___default()(address);
  }
}, __WEBPACK_IMPORTED_MODULE_8__socket_mutations__["a" /* default */], {
  resetDirtyFlag: function resetDirtyFlag(state) {
    state.dirty = false;
    console.info('Saved!');
  },
  setPresentation: function setPresentation(state, presentation) {
    state.presentation = presentation;
  },
  setTitle: function setTitle(state, title) {
    state.presentation.title = title;
  },
  setSlides: function setSlides(state, slides) {
    state.presentation.slides = slides;
    state.dirty = true;
  },
  setSelectedSlideIndex: function setSelectedSlideIndex(state, selectedIndex) {
    state.selectedSlideIndex = selectedIndex;
    state.selectedElementIndex = null;
  },
  setElements: function setElements(state, _ref40) {
    var slideIndex = _ref40.slideIndex,
        elements = _ref40.elements;

    state.presentation.slides[slideIndex].elements = elements;
    state.dirty = true;
  },
  setUsersList: function setUsersList(_ref41, usersList) {
    var commit = _ref41.commit;

    state.activeUsers = usersList;
  },
  zoomIn: function zoomIn(state) {
    var newValue = state.zoomLevel + ZOOM_STEP_LEVEL;

    if (newValue < 2.5) {
      state.zoomLevel = newValue;
    }
  },
  zoomOut: function zoomOut(state) {
    var newValue = state.zoomLevel - ZOOM_STEP_LEVEL;

    if (newValue > 0) {
      state.zoomLevel = newValue;
    }
  },
  setSelectedElementIndex: function setSelectedElementIndex(state, selectedElementIndex) {
    state.selectedElementIndex = selectedElementIndex;
  },
  createSlide: function createSlide(state) {
    if (!state.presentation) {
      console.error('Unable to create a new slide');
      return null;
    }

    state.presentation.slides.push(JSON.parse(DEFAULT_NEW_SLIDE));
    state.selectedSlideIndex = state.presentation.slides.length - 1;
    state.dirty = true;

    state.socket.emit('modified-slides', {
      presentationId: state.presentation.id,
      slides: state.presentation.slides
    });
  },
  deleteSlide: function deleteSlide(state, slideIndex) {
    if (!state.presentation.slides.length || !state.presentation.slides[slideIndex]) {
      console.error('Unable to delete slide');
      return null;
    }

    // Remove the slide
    state.presentation.slides.splice(slideIndex, 1);

    // Now show the next slide, or find something else to show
    if (!state.presentation.slides[slideIndex]) {
      if (state.presentation.slides[slideIndex - 1] !== null) {
        state.selectedSlideIndex = slideIndex - 1;
      } else if (state.presentation.slides.length) {
        state.selectedSlideIndex = state.presentation.slides.length - 1;
      } else {
        state.selectedSlideIndex = 0;
      }
    }
    state.dirty = true;

    state.socket.emit('modified-slides', {
      presentationId: state.presentation.id,
      slides: state.presentation.slides
    });
  },
  moveSlide: function moveSlide(state, _ref42) {
    var draggingSlideIndex = _ref42.draggingSlideIndex,
        replaceSlideIndex = _ref42.replaceSlideIndex;

    if (!state.presentation.slides.length || !state.presentation.slides[draggingSlideIndex] || !state.presentation.slides[replaceSlideIndex]) {
      console.error('Unable to move slide');
      return null;
    }

    state.presentation.slides.splice(draggingSlideIndex, 0, state.presentation.slides.splice(replaceSlideIndex, 1)[0]);
    state.selectedSlideIndex = replaceSlideIndex;
    state.dirty = true;
    state.socket.emit('modified-slides', {
      presentationId: state.presentation.id,
      slides: state.presentation.slides
    });
  },
  createText: function createText(state) {
    if (!state.presentation || !state.presentation.slides[state.selectedSlideIndex]) {
      console.error('Unable to create new text element: no active presentation and/or slide');
      return null;
    }
    var newTextElement = JSON.parse(DEFAULT_NEW_TEXT);
    var newElementId = state.presentation.slides[state.selectedSlideIndex].elements.length;
    newTextElement.id = newElementId;
    state.presentation.slides[state.selectedSlideIndex].elements.push(newTextElement);
    state.selectedElementIndex = newElementId;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  createImage: function createImage(state, _ref43) {
    var url = _ref43.url,
        height = _ref43.height,
        width = _ref43.width;

    if (!state.presentation || !state.presentation.slides[state.selectedSlideIndex]) {
      console.error('Unable to create new image element: no active presentation and/or slide');
      return null;
    }
    var newImageElement = JSON.parse(DEFAULT_NEW_IMAGE);
    newImageElement.properties.href = url;
    newImageElement.properties.width = width;
    newImageElement.properties.height = height;
    var newElementId = Date.now();
    newImageElement.id = newElementId;
    state.presentation.slides[state.selectedSlideIndex].elements.push(newImageElement);
    state.selectedElementIndex = newElementId;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  deleteElement: function deleteElement(state, selectedElementIndex) {
    if (!state.presentation.slides.length || !state.presentation.slides[state.selectedSlideIndex].elements.length || !state.presentation.slides[state.selectedSlideIndex].elements.find(function (el) {
      return el.id === selectedElementIndex;
    })) {
      console.error('Unable to delete element');
    }

    var slide = state.presentation.slides[state.selectedSlideIndex];
    slide.elements = slide.elements.filter(function (el) {
      return el.id !== selectedElementIndex;
    });
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setBackgroundColour: function setBackgroundColour(state, newBackgroundColour) {
    if (!state.presentation.slides.length || !state.presentation.slides[state.selectedSlideIndex]) {
      return null;
    }

    state.presentation.slides[state.selectedSlideIndex].backgroundColour = newBackgroundColour;
    state.dirty = true;
    state.socket.emit('changed-slide-background-colour', {
      slideIndex: state.selectedSlideIndex,
      slide: state.presentation.slides[state.selectedSlideIndex]
    });
  },
  replaceSlide: function replaceSlide(state, _ref44) {
    var slideIndex = _ref44.slideIndex,
        slide = _ref44.slide;

    state.dirty = true;
    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(state.presentation.slides, slideIndex, slide);
  },
  setElementX: function setElementX(state, _ref45) {
    var element = _ref45.element,
        value = _ref45.value;

    if (!element) {
      console.error('Failed to set the X coordinate for an element (element was null)');
      return null;
    }
    element.properties.x = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementY: function setElementY(state, _ref46) {
    var element = _ref46.element,
        value = _ref46.value;

    if (!element) {
      console.error('Failed to set the Y coordinate for an element (element was null)');
      return null;
    }
    element.properties.y = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementCoordinates: function setElementCoordinates(state, _ref47) {
    var element = _ref47.element,
        x = _ref47.x,
        y = _ref47.y;

    if (!element) {
      console.error('Failed to set coordinates for an element (element was null)');
      return null;
    }
    element.properties.x = x;
    element.properties.y = y;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementFontFamily: function setElementFontFamily(state, _ref48) {
    var element = _ref48.element,
        value = _ref48.value;

    if (!element) {
      console.error('Failed to set the font family for an element (element was null)');
      return null;
    }
    element.properties.fontFamily = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementFontSize: function setElementFontSize(state, _ref49) {
    var element = _ref49.element,
        value = _ref49.value;

    if (!element) {
      console.error('Failed to set the font size for an element (element was null)');
      return null;
    }
    element.properties.fontSize = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementFill: function setElementFill(state, _ref50) {
    var element = _ref50.element,
        value = _ref50.value;

    if (!element) {
      console.error('Failed to set the fill for an element (element was null)');
      return null;
    }
    element.properties.fill = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  },
  setElementContent: function setElementContent(state, _ref51) {
    var element = _ref51.element,
        value = _ref51.value;

    if (!element) {
      console.error('Failed to set the content for an element (element was null)');
      return null;
    }
    element.properties.content = value;
    state.dirty = true;
    state.socket.emit('modified-elements', {
      slideIndex: state.selectedSlideIndex,
      elements: state.presentation.slides[state.selectedSlideIndex].elements
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  notifyRenamedPresentation: function notifyRenamedPresentation(state, _ref) {
    var title = _ref.title;

    state.socket.emit('renamed-presentation', {
      presentationId: state.presentation.id,
      newTitle: title
    });
  },
  notifyCreatedElement: function notifyCreatedElement(state, _ref2) {
    var elements = _ref2.elements;

    state.socket.emit('created-element', elements);
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_presentation__ = __webpack_require__(38);





var state = {
  selectedSlideIndex: 0,

  presentation: {
    id: -1,
    title: '',
    slides: []
  }
};

var getters = {
  presentation: function presentation(state) {
    return state.presentation;
  },
  presentationId: function presentationId(state) {
    return state.presentation ? state.presentation.id : -1;
  },
  title: function title(state) {
    return state.presentation.title;
  },
  currentSlide: function currentSlide(state) {
    if (!state.presentation.slides.length || !state.presentation.slides[state.selectedSlideIndex]) {
      return null;
    }

    return state.presentation.slides[state.selectedSlideIndex];
  },
  selectedSlideIndex: function selectedSlideIndex(state) {
    return state.selectedSlideIndex;
  },
  slides: function slides(state) {
    return state.presentation.slides;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  }
};

var actions = {
  fetchPresentation: function fetchPresentation(_ref, presentationId) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                  var res;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;

                          commit('setPageLoading', true, { root: true });
                          _context.next = 4;
                          return __WEBPACK_IMPORTED_MODULE_3__api_presentation__["b" /* getPresentation */](presentationId);

                        case 4:
                          res = _context.sent;


                          commit('setPresentation', res.data.presentation);
                          commit('setPageLoading', false, { root: true });
                          resolve();
                          _context.next = 14;
                          break;

                        case 10:
                          _context.prev = 10;
                          _context.t0 = _context['catch'](0);

                          console.error(_context.t0);
                          reject(_context.t0);

                        case 14:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[0, 10]]);
                }));

                return function (_x, _x2) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  next: function next(_ref3) {
    var commit = _ref3.commit;

    commit('nextSlide');
  },
  previous: function previous(_ref4) {
    var commit = _ref4.commit;

    commit('previousSlide');
  }
};

var mutations = {
  setPresentation: function setPresentation(state, presentation) {
    state.presentation = presentation;
  },
  setTitle: function setTitle(state, title) {
    state.presentation.title = title;
  },
  setSlides: function setSlides(state, slides) {
    state.presentation.slides = slides;
  },
  setSelectedSlideIndex: function setSelectedSlideIndex(state, selectedIndex) {
    state.selectedSlideIndex = selectedIndex;
  },
  nextSlide: function nextSlide(state) {
    var newIndex = state.selectedSlideIndex + 1;

    if (state.presentation.slides.length && state.presentation.slides[newIndex]) {
      state.selectedSlideIndex = newIndex;
    }
  },
  previousSlide: function previousSlide(state) {
    var newIndex = state.selectedSlideIndex - 1;

    if (state.presentation.slides.length && state.presentation.slides[newIndex]) {
      state.selectedSlideIndex = newIndex;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(45);


var _mutations;





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    current: null
  },
  getters: {
    current_user: function current_user(state) {
      return state.current;
    },
    is_logged_in: function is_logged_in(state) {
      return state.current !== null;
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* AUTHENTICATE_USER */], function (state, user) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'current', user);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOG_OUT */], function (state) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state, 'current', null);
  }), _mutations)
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(46);




var AppLanding = function AppLanding() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 206));
};
var LoginForm = function LoginForm() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 207));
};
var RegistrationForm = function RegistrationForm() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 208));
};

// Page modules (loaded only when needed)
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 209));
};
var Editor = function Editor() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 210));
};
var Presenter = function Presenter() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 211));
};
var PageNotFound = function PageNotFound() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 212));
};

// Meta objects reused across routes
var showLoading = { showLoading: true };

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ name: 'landing', path: '/', component: AppLanding, meta: { auth: undefined } }, { name: 'auth.login', path: '/login', component: LoginForm, meta: { auth: false } }, { name: 'auth.register', path: '/register', component: RegistrationForm, meta: { auth: false } }, { name: 'editor', path: '/editor/:presentationId', component: Editor, meta: showLoading }, { name: 'presenter', path: '/presenter/:presentationId', component: Presenter, meta: { showLoading: showLoading, auth: true, hideTopBar: true } }, { name: 'dashboard', path: '/dashboard', component: Dashboard, meta: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, showLoading, { auth: true }) }, { name: 'page-not-found', path: '*', component: PageNotFound }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var position = { x: 0, y: 0
      // Keep scroll position when using browser buttons
    };if (savedPosition) {
      position = savedPosition;
    }

    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        resolve(position);
      }, 1000);
    });
  }
}));

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPresentations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return savePresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deletePresentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(67);


var getPresentation = function getPresentation(id, success, failure) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('/presentations/' + id).then(success).catch(failure);
};

var getPresentations = function getPresentations(success, failure) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('/presentations').then(success).catch(failure);
};

var savePresentation = function savePresentation(presentation, success, failure) {
  if (presentation.id) {
    // Updating existing presentation
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].put('/presentations/' + presentation.id, presentation).then(success).catch(failure);
  }
  // Create new presentation
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].post('/presentations', presentation).then(success).catch(failure);
};

var deletePresentation = function deletePresentation(id, success, failure) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete('/presentations/' + id).then(success).catch(failure);
};

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHENTICATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOG_OUT; });
var AUTHENTICATE_USER = 'AUTHENTICATE_USER';
var LOG_OUT = 'LOG_OUT';

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoadingOverlay_vue__ = __webpack_require__(142);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'top-bar': __WEBPACK_IMPORTED_MODULE_2__components_TopBar_vue__["a" /* default */],
    'loading-overlay': __WEBPACK_IMPORTED_MODULE_3__components_LoadingOverlay_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['pageLoading']), {
    hideTopBar: function hideTopBar() {
      return this.$route.meta.hideTopBar;
    },
    appConditionalStyles: function appConditionalStyles() {
      return {
        'top-bar-hidden': this.hideTopBar
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setPageLoading'])),
  watch: {
    '$route': function $route(route) {
      if (route.meta.showLoading) {
        this.setPageLoading(true);
      }
    }
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_clipboard2__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_clipboard2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_clipboard2___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'top-bar',
  data: function data() {
    return {
      userTyping: false,
      timer: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['pageLoading', 'savingState']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('editor', ['title', 'presentationId', 'presentation']), {
    presentationTitle: {
      get: function get() {
        return this.title;
      },
      set: function set(value) {
        this.updateTitle(value);
      }
    },
    presentationUrl: function presentationUrl() {
      return window.location.href;
    },
    hideTopBar: function hideTopBar() {
      return this.$route.meta.hideTopBar;
    },
    displayBack: function displayBack() {
      return this.$route.name !== 'dashboard' && this.$route.name !== 'landing';
    },
    editorMode: function editorMode() {
      return this.$route.name === 'editor';
    },
    user: function user() {
      return this.$auth.user();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setPageLoading']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('editor', ['updateTitle', 'renamePresentation', 'savePresentation']), {
    logout: function logout() {
      var _this = this;

      this.$auth.logout();
      this.setPageLoading(true);
      this.$router.push({ name: 'landing' });
      setTimeout(function () {
        _this.setPageLoading(false);
      }, 500);
    },
    onCopy: function onCopy(e) {
      window.alert('Editing link copied to clipboard');
    },
    onError: function onError(e) {
      window.alert('Failed to copy link');
    },
    onBlur: function onBlur(_ref) {
      var value = _ref.target.value;

      this.renamePresentation({
        presentationId: this.presentationId,
        newTitle: value
      });
    },

    doSavePresentation: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.savePresentation({ presentation: this.presentation });

              case 2:
                alert('Presentation Saved');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function doSavePresentation() {
        return _ref2.apply(this, arguments);
      }

      return doSavePresentation;
    }()
  })
});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading-overlay',
  props: { show: Boolean }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);



var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: '/api' });
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common.Authorization = 'Bearer ' + localStorage['jwt-token'];
axiosInstance.interceptors.response.use(function (res) {
  // Unauthorized Access
  if (res.status === 401 && ['UnauthorizedAccess', 'InvalidToken'].indexOf(res.data.code) > -1) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.logout({
      redirect: { name: 'landing' }
    });
  } else if (res.status === 500) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router.push({ name: 'landing' });
  } else if (res.status === 404) {
    // TODO: add 404 component
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.logout();
  }
  return res;
});

/* harmony default export */ __webpack_exports__["a"] = (axiosInstance);

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_slides_editor__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_presenter__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_user__ = __webpack_require__(195);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  state: {
    pageLoading: false,
    savingState: false,
    changeDelayTimer: null
  },
  getters: {
    pageLoading: function pageLoading(state) {
      return state.pageLoading;
    },
    savingState: function savingState(state) {
      return state.savingState;
    },
    changeDelayTimer: function changeDelayTimer(state) {
      return state.changeDelayTimer;
    }
  },
  actions: {
    setPageLoading: function setPageLoading(_ref, pageLoading) {
      var commit = _ref.commit;

      commit('setPageLoading', pageLoading);
    }
  },
  mutations: {
    setPageLoading: function setPageLoading(state, pageLoading) {
      state.pageLoading = pageLoading;
    },
    setTimeout: function (_setTimeout) {
      function setTimeout(_x, _x2) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (state, fn) {
      state.savingState = true;
      state.changeDelayTimer = setTimeout(fn, 5000);
    }),
    clearTimeout: function (_clearTimeout) {
      function clearTimeout(_x3) {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function (state) {
      console.log('Cancelled save event');
      state.savingState = false;
      clearTimeout(state.changeDelayTimer);
    })
  },
  modules: {
    dashboard: __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__["a" /* default */],
    editor: __WEBPACK_IMPORTED_MODULE_3__modules_slides_editor__["a" /* default */],
    presenter: __WEBPACK_IMPORTED_MODULE_4__modules_presenter__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_5__modules_user__["a" /* default */]
  }
});

store.watch(function () {
  return store.getters['editor/dirty'];
}, function (value) {
  if (!store.getters['savingState'] && store.getters['editor/dirty']) {
    console.info('Saving..');
    store.commit('clearTimeout');
    store.commit('setTimeout', function () {
      return store.dispatch('editor/savePresentation', {
        presentation: store.getters['editor/presentation']
      }).then(function () {
        return store.commit('editor/resetDirtyFlag');
      });
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(73);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default.a, __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */]);

/* eslint-disable no-new */
window.App = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: 'main',
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74199372_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(145);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74199372_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[87]);


// WEBPACK FOOTER //
// static/js/app.9e92cac61954041eb79c.js